import { render, staticRenderFns } from "./news_headlines.vue?vue&type=template&id=13f7c6d2&"
import script from "./news_headlines.vue?vue&type=script&lang=js&"
export * from "./news_headlines.vue?vue&type=script&lang=js&"
import style0 from "./news_headlines.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports